import { z } from 'zod';

export const courtFormSchema = z.object({
  name: z.string().min(1, 'Court name is required').max(100, 'Name too long'),
  surfaceType: z
    .enum(['hard', 'clay', 'grass', 'indoor', 'synthetic', 'wood', 'carpet'])
    .optional(),
  courtType: z.enum(['singles', 'doubles', 'both']).optional(),
  isActive: z.boolean(),
  availableForHire: z.boolean().optional(),
  academySportIds: z.array(z.string().uuid()).min(1, 'Select at least one sport').optional(),
  sportMetadata: z.record(z.unknown()).optional(),
  /** Empty string = unassigned (validated on server when set) */
  locationId: z.union([z.string().uuid(), z.literal('')]).optional(),
});

export type CourtFormData = z.infer<typeof courtFormSchema>;
